module.exports = __webpack_public_path__ + "img/home-img1.75c33097.png";